import {Auth, Toast} from '@/helpers'

export default {
  data() {
    return {
      error: null
    }
  },
  watch: {
    error(e) {
      if (e) {
        if (e.response && e.response.status === 401 && Auth.isAuthenticated()) {
          Toast.show('Votre session a expirée, veuillez vous reconnecter...', 5000)
          this.logout(true)
        }
        else
          Toast.error(this.errorMessage)
      }
    }
  },
  computed: {
    hasError() {
      return !!this.error
    },
    errorMessage() {
      if (this.error) {
        if (this.error.response) { // HTTP error
          if (this.error.response.status === 500)
            return "Une erreur est survenue sur le serveur."

          if (this.error.response.data)
            return this.error.response.data.message
        }

        if (this.error.message.match(/Network Error/i))
          return "Échec de la connexion au serveur..."

        return this.error.message
      }

      return null
    }
  }
}
